export default {"src":"/_next/static/media/34-icon.0ede444b.svg","height":46,"width":31,"blurWidth":0,"blurHeight":0};